import { render, staticRenderFns } from "./UserInboxOnReferenceObjects.vue?vue&type=template&id=61de4f07&scoped=true&"
import script from "./UserInboxOnReferenceObjects.vue?vue&type=script&lang=ts&"
export * from "./UserInboxOnReferenceObjects.vue?vue&type=script&lang=ts&"
import style0 from "./UserInboxOnReferenceObjects.vue?vue&type=style&index=0&id=61de4f07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61de4f07",
  null
  
)

export default component.exports